import React from "react";
import ControlTemplate from "../BaseControls/ControlTemplate";
import { controlPropTypes } from "../formhelpers";
import PropTypes from "prop-types";

export default class Label extends React.Component {
    render() {
        const {
            descriptor: {
                config = {},
            },
            value,
        } = this.props;
        const valueStr = ArmusScript["numberFormat(Number,String)"](value, config.mask) || "";
        return (
            <ControlTemplate {...this.props} className="integer-field" >
                <span>{valueStr}</span>
            </ControlTemplate>
        );
    }
}

Label.propTypes = controlPropTypes({
    mask: PropTypes.string.isRequired
});



// WEBPACK FOOTER //
// ./app/lib/common/descriptorcontrols/IntegerField/label.js